import React, { useState } from 'react';
import { FaSearch, FaHome, FaUser, FaServer, FaNetworkWired, FaHandshake, FaBars, FaBook, FaLock } from 'react-icons/fa';
import { checkTxid, checkBlockHash } from '../services/apiService';

const Header = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const detectSearchType = async (query) => {
    if (/^[a-f0-9]{64}$/i.test(query)) {
      const isTxid = await checkTxid(query);
      if (isTxid) return isTxid;

      const isBlockHash = await checkBlockHash(query);
      if (isBlockHash) return isBlockHash;

      return null;
    } else if (/^[a-zA-Z0-9]{34}$/.test(query)) {
      return 'address';
    }
    
    return null;
  };

  const handleSearch = async (e) => {
    e.preventDefault();
    const trimmedQuery = searchQuery.trim();

    if (!trimmedQuery) {
      alert('Por favor, ingresa un valor válido.');
      return;
    }

    const searchType = await detectSearchType(trimmedQuery);

    if (searchType) {
      window.location.href = `/${searchType}/${trimmedQuery}`;
    } else {
      alert('No se encontró resultado. Verifica el bloque, txid o dirección.');
    }
  };

  return (
    <header className="bg-gray-800 text-white p-4">
      <div className="container mx-auto flex flex-wrap items-center justify-between">
        <div className="flex items-center">
          <img src="/logo.webp" alt="Logo" className="h-10 w-10 mr-2" />
          <h1 className="text-2xl font-bold">Menelik</h1>
        </div>

        {/* Botón Menú Hamburguesa (Móvil) */}
        <button
          className="lg:hidden text-white text-2xl"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          aria-label="Toggle menu"
        >
          <FaBars />
        </button>

        {/* Formulario */}
        <form className="flex items-center flex-1 max-w-lg mx-auto mt-4 lg:mt-0 lg:mx-4" onSubmit={handleSearch}>
          <input
            type="text"
            placeholder="Enter block hash, transaction ID, or address"
            className="border border-gray-300 rounded-l-md px-4 py-2 w-full bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <button
            type="submit"
            className="bg-blue-500 text-white px-4 py-2 rounded-r-md hover:bg-blue-600 flex items-center"
          >
            <FaSearch className="mr-2" /> Search
          </button>
        </form>

        <nav className={`${isMenuOpen ? 'block' : 'hidden'} lg:flex lg:items-center lg:space-x-4 w-full lg:w-auto mt-4 lg:mt-0`}>
          <ul className="flex flex-col lg:flex-row space-y-2 lg:space-y-0 lg:space-x-4"> 
            <li><a href="/" className="hover:underline flex items-center"><FaHome className="mr-1" /> Home</a></li>
            <li><a href="/top-addresses" className="hover:underline flex items-center"><FaUser className="mr-1" /> Holders</a></li>
            <li><a href="/locked-coins" className="hover:underline flex items-center"><FaLock className="mr-1" /> Locked Coins</a></li>
            <li><a href="/smartnodes" className="hover:underline flex items-center"><FaServer className="mr-1" /> SmartNodes</a></li>
            <li><a href="/claim-address" className="hover:underline flex items-center"><FaHandshake className="mr-1" /> Claim Address</a></li>
            <li><a href="/peerinfo" className="hover:underline flex items-center"><FaNetworkWired className="mr-1" /> Peers</a></li>
            <li><a href="/api-docs" className="hover:underline flex items-center"><FaBook className="mr-1" /> Api</a></li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
